/**
 * BrowserStorage
 * @public
 */
export class BrowserStorage {
  constructor() {
    this.storage = window.sessionStorage;
  }
  getItem(key) {
    return this.storage.getItem(key);
  }
  setItem(key, value) {
    this.storage.setItem(key, value);
  }
  removeItem(key) {
    this.storage.removeItem(key);
  }
}